// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"ee1aef5682ac2576","5285":"bc317d4582e04ec5"}[chunkId] + ".css";
};